import { ChatPanel } from 'app/components/dashboard/chat/ChatPanel';
import { RootState } from 'app/redux/store';
import { setNewChatMessages } from 'app/redux/features/dashboard/dashboard-slice';
import { connect } from 'react-redux';
import { Flex } from 'app/components/common/Flex';
import React from 'react';
import Utils from 'app/common/util/Utils';
import ConditionalRender from 'app/common/components/ConditionalRender';
import { Input, Select } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import TimeUtils from 'app/common/util/TimeUtils';

export class MiniChatPanel extends ChatPanel {
    render() {
        const messagesPerUser = this.getMessagesPerUser(this.state.chatData?.messages);
        const users = Utils.isExists(messagesPerUser?.keys()) ? Array.from(messagesPerUser.keys()) : [];
        const unreadMessagesPerUser = new Map<string, number>();
        messagesPerUser?.forEach((value, key) => {
            const unread = value.filter(msg => msg['read'] === false)?.length;
            unreadMessagesPerUser.set(key, unread);
        });

        const messages = messagesPerUser?.get(this.state.toUserId);

        return (
            <Flex direction={'vertical'} style={{ padding: '1em', gap: '0.5em', height: '100%' }}>
                <Flex size="4em">
                    {this.renderUsers(
                        this.getUsers(this.state.knownOtherUsers, users),
                        this.state.chatData?.presences,
                        unreadMessagesPerUser,
                    )}
                </Flex>
                <Flex size={'2em'} style={{ gap: '2em', alignItems: 'center' }}>
                    <div>Channel</div>
                    <Select style={{ width: '10em' }} value={this.state.toUserId} onChange={this.doChangeSendTo}>
                        {this.getUsers(this.state.knownOtherUsers, users).map(userId => (
                            <Select.Option key={userId} value={userId}>
                                {userId}
                            </Select.Option>
                        ))}
                    </Select>
                </Flex>
                <div className={'overflow'} ref={this.messagesRef}>
                    <ConditionalRender condition={Utils.isNotExists(messages?.length)}>
                        <div style={{ textAlign: 'center', padding: '0.5em' }}>No messages</div>
                    </ConditionalRender>
                    {messages?.map((chatMessage, idx) => {
                        return (
                            <div
                                key={idx}
                                style={{ paddingBottom: '0.5em', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                <Flex style={{ gap: '1em' }}>
                                    <span>{TimeUtils.formatHHMM(chatMessage.timestamp)}</span>:
                                    <span>{chatMessage.fromId}</span>
                                </Flex>
                                <span style={{ color: 'white', lineHeight: '1.2em', fontSize: '1.2em' }}>
                                    {chatMessage.message}
                                </span>
                            </div>
                        );
                    })}
                </div>
                <Input
                    value={this.state.message}
                    placeholder="Write a message..."
                    onChange={event => this.setState({ message: event.target.value })}
                    onKeyDown={this.doHandleMessageKeyDown}
                    addonAfter={<SendOutlined />}
                />
            </Flex>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {
    setNewChatMessages,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(MiniChatPanel);
